import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

export default () => {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="footer">
      <div className="inner">
        <div className="charities">
          <h3>Charities we Support</h3>
          <p>
            <a href="https://www.hospiceintheweald.org.uk/">
              Hospice in the Weald
            </a>
          </p>
          <p>
            <a href="https://ngs.org.uk/">National Garden Scheme</a>
          </p>
        </div>
        <div className="contact">
          <h3>Contact Us</h3>
          <p>
            <FontAwesomeIcon icon="phone" /> |{" "}
            <a href="tel:01892542233">01892 542233</a>
          </p>
          <p>
            <FontAwesomeIcon icon="at" /> |{" "}
            <a href="mailto:carole.marks@btinternet.com">
              carole.marks@btinternet.com
            </a>
          </p>
          <p>
            <FontAwesomeIcon icon="map-marker-alt" /> | 2, St. Lawrence Avenue,
            Bidborough, Tunbridge Wells, Kent. TN4 0XB.
          </p>
        </div>
      </div>
      <div className="legal">
        <small>
          &copy; Copyright {currentYear} Boundes End Garden |
          www.boundesendgarden.co.uk
        </small>
      </div>
    </footer>
  )
}
